export const axisBand = {
    domainLine: {
        visible: !0
    },
    grid: {
        visible: !1
    },
    subGrid: {
        visible: !1
    },
    tick: {
        visible: !0
    },
    subTick: {
        visible: !1
    }
};
//# sourceMappingURL=band-axis.js.map
